import { DeviceMode } from '@vedalib/editor'
import type { SidebarSchemaType } from '@vedalib/editor/lib/brand'
import { MenuPositionType, SidebarMenuType } from '@vedalib/editor/lib/brand'
import cn from 'classnames'
import { forwardRef, type ReactNode } from 'react'

import type { ElementStyleCss } from 'services/Branding/types'
import type { IBlockMode } from 'services/Store/Project/types'

import * as s from './CourseSidebarLayout.module.scss'

interface ICourseSidebarLayout {
  styles: ElementStyleCss<SidebarSchemaType>
  children: ReactNode
  mode: IBlockMode
  width?: number | string
}

const CourseSidebarLayout = forwardRef<HTMLElement, ICourseSidebarLayout>(
  ({ styles, children, mode, width }, ref) => {
    const menuPosition = styles.menu.position as MenuPositionType
    const fixed = styles.menu.type === SidebarMenuType.fixed
    const isDrawer = styles.menu.type === SidebarMenuType.drawer
    const isMobile = mode.deviceMode === DeviceMode.mobile
    const rootStyles = { backgroundColor: styles.menu.backgroundColor, width, ...styles.effects }
    const rootCn = cn(s.root, {
      [s.positionRight]: menuPosition === MenuPositionType.right,
      [s.fluid]: isMobile && fixed,
    })

    return (
      <nav
        aria-label='Navigation menu'
        aria-modal={isDrawer}
        className={rootCn}
        ref={ref}
        style={rootStyles}
      >
        <div className={s.container}>{children}</div>
      </nav>
    )
  },
)
export default CourseSidebarLayout
